export default __webpack_public_path__ + "static/media/img1.7e5b381a.png";